import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

const isSecure = window.location.protocol === 'https:';
const host = import.meta.env.VITE_REVERB_HOST || window.location.hostname;
const port = import.meta.env.VITE_REVERB_PORT || (isSecure ? 443 : 80);
const scheme = import.meta.env.VITE_REVERB_SCHEME || (isSecure ? 'https' : 'http');

const EchoConnection = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: host,
  wsPort: port,
  wssPort: port,
  forceTLS: scheme === 'https',
  enabledTransports: ['ws', 'wss'],
});

export default function () {
  return EchoConnection;
}
